export default function getArray(input) {
  // Normalize common API shapes into an array
  if (!input) return [];
  if (Array.isArray(input)) return input;
  if (typeof input === 'object') {
    if (Array.isArray(input.data)) return input.data;
    // some endpoints return { items: [...] }
    if (Array.isArray(input.items)) return input.items;
  }
  return [];
}
